/** Parse variation_attributes (Color, Size, …) into normalized analytics fields. */

export type VariationAttributeLike = { name: string; value: string };

export function parseVariationAttributesForAnalytics(
  attributes: VariationAttributeLike[] | null | undefined,
): { item_color?: string; item_size?: string } {
  const byName: Record<string, string> = {};
  for (const attr of attributes ?? []) {
    const name = attr?.name?.trim();
    const value = attr?.value?.trim();
    if (!name || !value) continue;
    byName[name.toLowerCase()] = value;
  }

  const color = byName.color ?? byName.colour;
  const size = byName.size;

  const out: { item_color?: string; item_size?: string } = {};
  if (color) out.item_color = color;
  if (size) out.item_size = size;
  return out;
}
